module.exports = __webpack_public_path__ + "img/warning-blue.71f73524.svg";